import React from "react";
import SkillsItem from "./SkillsItem";
import styles from "./SkillsMenu.module.css";
import ComputerIcon from "@mui/icons-material/Computer";
import StorageIcon from "@mui/icons-material/Storage";
import HandymanIcon from "@mui/icons-material/Handyman";
import TranslateIcon from "@mui/icons-material/Translate";

const frontend = [
  "HTML ",
  "CSS/SASS ",
  "JavaScript ",
  "React JS ",
  "NextJs",
  "Bootstrap ",
  "Tailwind ",
  "Material UI",
  "Vue",
  "Redux"
];
const backend = [
  "NodeJs ",
  "Solidity",
  ".NET",
  "Express ",
  "MySQL ",
  "MongoDB ",
  "Firebase",
];

const tools = ["Adobe Photoshop ", "Adobe Xd ", "Github ", "JEST ", "JIRA", "NPM",];
const languages = ["Spanish ", "English ", "Portuguese"];

const SkillsMenu = () => {
  return (
    <div className={styles.skillContainer} id="skills">
      <div className={styles.titleCtn}>
        <h2 className={styles.skillTitle}>Skills</h2>
      </div>
      <div className={styles.skillItemCtn}>
        <div className={styles.skillItemData}>
          <ComputerIcon fontSize="large" />
          <SkillsItem label="Front-End" item={frontend} />
        </div>
        <div className={styles.skillItemData}>
          <StorageIcon fontSize="large" />
          <SkillsItem label="Back-End" item={backend} />
        </div>
        <div className={styles.skillItemData}>
          <HandymanIcon fontSize="large" />
          <SkillsItem label="Tools" item={tools} />
        </div>
        <div className={styles.skillItemData}>
          <TranslateIcon fontSize="large" />
          <SkillsItem label="Languages" item={languages} />
        </div>
      </div>
    </div>
  );
};

export default SkillsMenu;
